// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const pav = require('../../package.json').preAlphaVersion
export const environment = {
    production: false,
    appVersion: require('../../package.json').version + (pav != "" ? "." + pav : ""),
    hmr: false,
    GENERATE_SOURCEMAP:false,
    apiUrl: 'http://localhost:4000'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
